import { styled } from "@mui/system";
import { colors } from '../../theme/colors';
import PhoneInput from "react-phone-input-2";
export const CustomPhoneInput = styled(PhoneInput)(({ theme }) => ({
  border: `1px solid ${colors.primary}`,
  ":hover": {
    border: `1px solid ${colors.primary}`,
  },
  borderRadius: "10px",
  "& .flag-dropdown": {
    borderRadius: "10px 0 0 10px",
    borderTop: "none",
    borderBottom: "none",
    border: "none",
  },
  "& .selected-flag:hover": {
    backgroundColor: "unset !important",
  },
  "& .open": {
    backgroundColor: "unset !important",
  },
  "& .form-control": {
    height: "55px",
    borderRadius: "10px",
    border: "none",
  },
}));
